import { forwardRef, type SelectHTMLAttributes } from 'react';
import { cn } from '@/lib/utils';

const base =
  'w-full rounded-lg bg-background text-foreground border border-primary/20 focus:border-primary focus:outline-hidden focus:ring-1 focus:ring-primary transition-colors';

const sizes = {
  sm: 'px-3 py-2 text-sm',
  md: 'p-3 text-sm',
} as const;

export interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  selectSize?: keyof typeof sizes;
}

export const Select = forwardRef<HTMLSelectElement, SelectProps>(({ className, selectSize = 'md', ...props }, ref) => {
  return <select ref={ref} className={cn(base, sizes[selectSize], className)} {...props} />;
});
Select.displayName = 'Select';
